import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=b1954d6a&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=ts"
export * from "./QuestionComponent.vue?vue&type=script&lang=ts"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=b1954d6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1954d6a",
  null
  
)

export default component.exports